export default {
  props: ["label", "type", "error", "name", "value", "icon", "ref"]
};